export const openTaskStatuses = new Set([
  "needed",
  "upload_started",
  "needs_new_copy",
  "not_started",
]);

export const readyTaskStatuses = new Set(["received", "being_reviewed", "done"]);

export const taskStatusClasses = {
  needed: "border-amber-200 bg-amber-50 text-amber-700",
  upload_started: "border-amber-200 bg-amber-50 text-amber-700",
  received: "border-emerald-200 bg-emerald-50 text-emerald-700",
  being_reviewed: "border-sky-200 bg-sky-50 text-sky-700",
  needs_new_copy: "border-rose-200 bg-rose-50 text-rose-700",
  done: "border-slate-200 bg-slate-100 text-slate-700",
  not_started: "border-slate-200 bg-slate-100 text-slate-700",
};

export function flattenChecklistTasks(checklist) {
  const sections = Array.isArray(checklist?.sections) ? checklist.sections : [];
  return sections.flatMap((section) => {
    if (Array.isArray(section.tasks) && section.tasks.length) {
      return section.tasks.map((task) => ({
        ...task,
        sectionTitle: section.title,
      }));
    }
    return (section.items || []).map((item) => ({
      code: `${section.title}-${item}`,
      title: item,
      body: section.body,
      category: section.title,
      status: "not_started",
      status_label: "Not started",
      action_label: "Review item",
      sectionTitle: section.title,
    }));
  });
}

export function getTaskActionPath(task) {
  if (task?.document_type) {
    const params = new URLSearchParams({
      document_type: task.document_type,
      task: task.code || "",
    });
    return `/documents?${params.toString()}`;
  }
  return "/checklist";
}
